import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const PrimaryBackground50Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${`${theme?.colour?.primary}0D`};
  `}
`;

export default Wrapper(PrimaryBackground50Wrapper)